import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Snack from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Cancel from "@material-ui/icons/Cancel";
// core components

import styles from "assets/jss/material-kit-react/components/snackbarContentStyle.js";

const useStyles = makeStyles(styles);

export default function SnackbarContent(props) {
  const { message, color, close, icon, id } = props;
  const classes = useStyles();
  var action = [];
  const onClose = function(){
    document.getElementById(id).style.visibility = "hidden";
  }
  if (close !== undefined) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={onClose}
        size="medium"
      >
        <Cancel className={classes.close} />
      </IconButton>
    ];
  }
  let snackIcon = null;
  switch (typeof icon) {
    case "object":
      snackIcon = <props.icon className={classes.icon} />;
      break;
    case "string":
      snackIcon = <Icon className={classes.icon}>{props.icon}</Icon>;
      break;
    default:
      snackIcon = null;
      break;
  }
  return (
  <Snack
    id = {id}
    message={
      <div className="semibold-b300">
        {snackIcon}
        {message}
        {close !== undefined ? action : null}
      </div>
    }
    classes={{
      root: classes.root + " " + classes[color],
      message: classes.message + " " + classes.container
    }}
    style={{ visibility: 'hidden' }}
  />
  );
}

SnackbarContent.propTypes = {
  message: PropTypes.node.isRequired,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  id:  PropTypes.string
};
